import React, { Component, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';

import { setMethodology } from '../../actions/';

const adviceText = require('../../model/adviceSection.json');

const AdviceSection = props => {

	
	const items = adviceText[props.section[0]][props.section[1]][0];

	// Action Dispatcher
	const dispatch = useDispatch();

	dispatch(setMethodology(props.methodologyData.section, props.methodologyData.subsection, props.methodologyData.indicator));

    const indicatorIcons = (pItem) => 
    {
        return pItem.icon;		
    }

	const content = (str1) => 
	{
		if(str1 == null){
			return null;
		} else {
			return <div className="advice-text">{ReactHtmlParser(props.literals[str1])}</div>;
		}
	}
	
	const sourceContent = (str1,str2,str3) =>
	{
		if(!str1){
			if(!str2){
				return null;
			}else{
				return <p><span className="">{ReactHtmlParser(props.literals[str2])}&nbsp;</span><span><Link className="" to={str3}>{props.literals.L20705}</Link></span></p>
			}
		} else if(!str2){
			return <p><span className="">{ReactHtmlParser(props.literals[str1])}&nbsp;</span></p>
		} else{
			return <p><span className="">{ReactHtmlParser(props.literals[str1])} {ReactHtmlParser(props.literals[str2])}&nbsp;</span><span><Link className="" to={str3}>{props.literals.L20705}</Link></span></p>
		}
	}

	return(
		<section data-ng-if="state.current.name != 'home'" id="not-home-cover" className="advice--icon--block advice--block-not-home background-main-light container-fluid section--page ng-scope">
			<div className="container horizontal-nopadding">                         
				<div className="text-advice left-text col-md-8 col-sm-8 col-xs-12  nopadding">
					<h1 className="main-color left-text title--section">
						{props.literals[items.title]}
					</h1>								
					{content(items.text)}
					{sourceContent(items.source, items.further, items.link)}				
				</div>
				<div className={"icon--advice hide-mobile col-sm-4 col-md-4 "+indicatorIcons(items)}>
				</div>			
			</div>
		</section>
	)
}

export default AdviceSection;